import React from "react";
import { graphql } from "gatsby";
import { makeDateForObjects } from "./../components/EverythingContext";
import ObjectLayout from "./../components/ObjectLayout";
import ObjectHeader from "./../components/ObjectHeader";
import { ObjectBody } from "./../components/ObjectLayout/elements";
import ObjectConnections from "./../components/ObjectConnections";
import ViewChooser from "./../components/ViewChooser";

const KeywordPage = ({ data, pageContext }) => {
  const { title, description } = data.keyword;
  const { pdfs, images, timelineEntries, walks } = data;
  // console.log(data, pageContext.id);

  const allTheData = makeDateForObjects(pdfs.nodes, "pdfFile", "pdf")
    .concat(makeDateForObjects(images.nodes, "imageFile", "image"))
    .concat(makeDateForObjects(timelineEntries.nodes, "", "timelineEvent"));

  return (
    <ObjectLayout title={`Keyword: ${title}`}>
      <ObjectHeader title={title} />
      {description ? (
        <ObjectBody>
          <p className="description">{description}</p>
        </ObjectBody>
      ) : null}
      <ViewChooser data={allTheData} />
      {pdfs.nodes.length ||
      images.nodes.length ||
      timelineEntries.nodes.lengh ||
      walks.nodes.length ? (
        <ObjectConnections
          pdfs={pdfs.nodes}
          images={images.nodes}
          timelineEntries={timelineEntries.nodes}
          walks={walks.nodes}
        />
      ) : null}
    </ObjectLayout>
  );
};

export default KeywordPage;

export const pageQuery = graphql`
  query($id: String!) {
    keyword: sanityKeyword(_id: { eq: $id }) {
      title
      description
    }
    pdfs: allSanityObjectPdf(
      filter: { keywords: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
        date
        dateApproximateness
        endDate
        endDateApproximateness
      }
    }
    images: allSanityObjectImage(
      filter: { keywords: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
        date
        dateApproximateness
        endDate
        endDateApproximateness
      }
    }
    timelineEntries: allSanityTimelineEntry(
      filter: { keywords: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
        date: startDate
        dateApproximateness
        endDate
        endDateApproximateness
      }
    }
    walks: allSanityWalk(
      filter: { keywords: { elemMatch: { _id: { eq: $id } } } }
    ) {
      nodes {
        _id
        title
      }
    }
  }
`;
